module.exports = __webpack_public_path__ + "static/bg200-b547dd60d1cf204020d99584c430e6fd.jpg";